import { gql } from "graphql-request"

const stellar = {
    name: 'stellar',
    title: ' Stellar Ledger',
    currency: 'XML',
    check: true,
    regexp: '([\\W]|^)(G[\\w]{55})([\\W]|$)',
    noregxp: [
        '([\\W]|^)(bnb[0-9a-z]{2})([\\W]|$)',
        '([\\W]|^)(bnb[0-9a-z]{2)([\\W]|$)',
        '([\\W]|^)(T[\\w]{2})([\\W]|$)',
        '([\\W]|^)((cosmos1|terra1|tcro1|tcrocncl1)[a-zA-HJ-NP-Z0-9]{38,70})([\\W]|$)',
    ],
    query: gql`query ($address: String!) {
        stellar(network: stellar) {
            address(address: {is: $address}) {
                balance:balance
                balance_usd: balance(in: USD)
            }
            ins: transfers(receiver: {is: $address}) {
                count
                min_date: minimum(of: date)
                max_date: maximum(of: date)
            }
            currencyIn: transfers(receiver: {is: $address}) {
                count
                currency: currencyTo {
                    symbol
                    address
                    tokenId: name
                }
            }
            outs: transfers(sender: {is: $address}) {
                count
                min_date: minimum(of: date)
                max_date: maximum(of: date)
            }
            currencyOut: transfers(sender: {is: $address}) {
                count
                currency: currencyTo {
                    symbol
                    address
                    tokenId: name
                }
            }
        }
    }`,
    checkAddress: 'GB4DJWXRQFZPVCXYOAUZ4XAFMBULRGA2ROJRDCEKYGVH2YKQTZJHCNNY',
}
export { stellar }
